// Canonical bundled Guide prose. IDs and dialog matchTitle are code authority;
// only the registered string values may be published through Control Centre.
export const TUTOR_DESK_GUIDE_UI_COPY = Object.freeze({
  "ui.available-guides": { "text": "Available guides", "groupId": "guide-controls", "groupLabel": "Guide controls and messages", "label": "Available guides", "maxLength": 240 },
  "ui.value-and-value": {
    "text": "{item} and {item2}",
    "groupId": "context-explanations",
    "groupLabel": "Window and menu explanations",
    "label": "[item] and [item2]",
    "maxLength": 240
  },
  "ui.value-and-value-d21041b": {
    "text": "{value1}, and {value2}",
    "groupId": "context-explanations",
    "groupLabel": "Window and menu explanations",
    "label": "[value1], and [value2]",
    "maxLength": 240
  },
  "prepare.close-guide-then-finish-or-close-the-current-window-or-menu-reopen-g": {
    "text": "Close Guide, then finish or close the current window or menu. Reopen Guide and choose this task so your unfinished work is not discarded.",
    "groupId": "preparation",
    "groupLabel": "Before you start",
    "label": "Close Guide, then finish or close the current window or menu. Reopen Guide and choose this task so y",
    "maxLength": 4000
  },
  "prepare.choose-quick-actions-add-lesson-on-home": {
    "text": "Choose Quick Actions → Add Lesson on Home.",
    "groupId": "preparation",
    "groupLabel": "Before you start",
    "label": "Choose Quick Actions → Add Lesson on Home.",
    "maxLength": 4000
  },
  "prepare.choose-quick-actions-add-lesson-on-calendar": {
    "text": "Choose Quick Actions → Add Lesson on Calendar.",
    "groupId": "preparation",
    "groupLabel": "Before you start",
    "label": "Choose Quick Actions → Add Lesson on Calendar.",
    "maxLength": 4000
  },
  "prepare.choose-quick-actions-add-student-on-home": {
    "text": "Choose Quick Actions → Add Student on Home.",
    "groupId": "preparation",
    "groupLabel": "Before you start",
    "label": "Choose Quick Actions → Add Student on Home.",
    "maxLength": 4000
  },
  "prepare.choose-add-student-or-open-a-student-and-choose-edit-student": {
    "text": "Choose Add Student, or open a student and choose Edit Student.",
    "groupId": "preparation",
    "groupLabel": "Before you start",
    "label": "Choose Add Student, or open a student and choose Edit Student.",
    "maxLength": 4000
  },
  "prepare.choose-quick-actions-add-edit-subject-on-home": {
    "text": "Choose Quick Actions → Add/Edit Subject on Home.",
    "groupId": "preparation",
    "groupLabel": "Before you start",
    "label": "Choose Quick Actions → Add/Edit Subject on Home.",
    "maxLength": 4000
  },
  "prepare.choose-quick-actions-plan-next-week": {
    "text": "Choose Quick Actions → Plan Next Week.",
    "groupId": "preparation",
    "groupLabel": "Before you start",
    "label": "Choose Quick Actions → Plan Next Week.",
    "maxLength": 4000
  },
  "prepare.choose-quick-actions-manage-availability-on-calendar": {
    "text": "Choose Quick Actions → Manage Availability on Calendar.",
    "groupId": "preparation",
    "groupLabel": "Before you start",
    "label": "Choose Quick Actions → Manage Availability on Calendar.",
    "maxLength": 4000
  },
  "prepare.choose-quick-actions-auditing-on-calendar": {
    "text": "Choose Quick Actions → Auditing on Calendar.",
    "groupId": "preparation",
    "groupLabel": "Before you start",
    "label": "Choose Quick Actions → Auditing on Calendar.",
    "maxLength": 4000
  },
  "prepare.open-auditing-on-calendar-choose-the-date-and-lesson-status-then-ope": {
    "text": "Open Auditing on Calendar, choose the date and lesson status, then open the lesson.",
    "groupId": "preparation",
    "groupLabel": "Before you start",
    "label": "Open Auditing on Calendar, choose the date and lesson status, then open the lesson.",
    "maxLength": 4000
  },
  "prepare.choose-a-student-on-progress-then-open-the-action-to-add-a-progress": {
    "text": "Choose a student on Progress, then open the action to add a progress check.",
    "groupId": "preparation",
    "groupLabel": "Before you start",
    "label": "Choose a student on Progress, then open the action to add a progress check.",
    "maxLength": 4000
  },
  "prepare.choose-a-student-on-progress-then-open-the-action-to-create-a-learni": {
    "text": "Choose a student on Progress, then open the action to create a learning goal.",
    "groupId": "preparation",
    "groupLabel": "Before you start",
    "label": "Choose a student on Progress, then open the action to create a learning goal.",
    "maxLength": 4000
  },
  "prepare.open-the-student-s-portal-action-and-choose-link-student-portal": {
    "text": "Choose Link on the student's card to open the Link Student Portal window.",
    "groupId": "preparation",
    "groupLabel": "Before you start",
    "label": "Open the student's Portal linking window.",
    "maxLength": 4000
  },
  "prepare.open-requested-lessons-find-the-request-and-choose-decline": {
    "text": "Open Requested Lessons, find the request, and choose Decline.",
    "groupId": "preparation",
    "groupLabel": "Before you start",
    "label": "Open Requested Lessons, find the request, and choose Decline.",
    "maxLength": 4000
  },
  "prepare.choose-add-link-in-library-or-open-a-saved-link-s-edit-action": {
    "text": "Choose Add Link in Library, or open a saved link’s Edit action.",
    "groupId": "preparation",
    "groupLabel": "Before you start",
    "label": "Choose Add Link in Library, or open a saved link’s Edit action.",
    "maxLength": 4000
  },
  "prepare.choose-new-collection-in-library": {
    "text": "Choose New Collection in Library.",
    "groupId": "preparation",
    "groupLabel": "Before you start",
    "label": "Choose New Collection in Library.",
    "maxLength": 4000
  },
  "prepare.choose-restore-jsonl-in-library": {
    "text": "Choose Restore JSONL in Library.",
    "groupId": "preparation",
    "groupLabel": "Before you start",
    "label": "Choose Restore JSONL in Library.",
    "maxLength": 4000
  },
  "prepare.find-the-lesson-in-home-or-calendar-open-its-actions-and-choose-edit": {
    "text": "Find the lesson in Home or Calendar, open its actions, and choose Edit.",
    "groupId": "preparation",
    "groupLabel": "Before you start",
    "label": "Find the lesson in Home or Calendar, open its actions, and choose Edit.",
    "maxLength": 4000
  },
  "prepare.find-the-lesson-in-home-or-calendar-and-choose-its-complete-action": {
    "text": "Find the lesson in Home or Calendar and choose its Complete action.",
    "groupId": "preparation",
    "groupLabel": "Before you start",
    "label": "Find the lesson in Home or Calendar and choose its Complete action.",
    "maxLength": 4000
  },
  "prepare.find-the-lesson-in-home-or-calendar-and-choose-its-cancel-action": {
    "text": "Find the lesson in Home or Calendar and choose its Cancel action.",
    "groupId": "preparation",
    "groupLabel": "Before you start",
    "label": "Find the lesson in Home or Calendar and choose its Cancel action.",
    "maxLength": 4000
  },
  "prepare.choose-quick-actions-record-payment-then-select-the-student-whose-pa": {
    "text": "Choose Quick Actions → Record Payment, then select the student whose payment you received.",
    "groupId": "preparation",
    "groupLabel": "Before you start",
    "label": "Choose Quick Actions → Record Payment, then select the student whose payment you received.",
    "maxLength": 4000
  },
  "prepare.choose-quick-actions-balances-and-select-the-student-and-period-you": {
    "text": "Choose Quick Actions → Balances and select the student and period you want to review.",
    "groupId": "preparation",
    "groupLabel": "Before you start",
    "label": "Choose Quick Actions → Balances and select the student and period you want to review.",
    "maxLength": 4000
  },
  "prepare.on-payments-choose-invoices-beside-quick-actions-to-open-the-invoice": {
    "text": "On Payments, choose Invoices beside Quick Actions to open the invoice workspace.",
    "groupId": "preparation",
    "groupLabel": "Before you start",
    "label": "On Payments, choose Invoices beside Quick Actions to open the invoice workspace.",
    "maxLength": 4000
  },
  "prepare.on-payments-open-invoices-find-an-existing-draft-and-choose-open-bes": {
    "text": "On Payments, open Invoices, find an existing draft, and choose Open beside it.",
    "groupId": "preparation",
    "groupLabel": "Before you start",
    "label": "On Payments, open Invoices, find an existing draft, and choose Open beside it.",
    "maxLength": 4000
  },
  "prepare.open-an-invoice-draft-review-its-details-then-choose-issue-invoice-w": {
    "text": "Open an invoice draft, review its details, then choose Issue Invoice when you are ready for the final review.",
    "groupId": "preparation",
    "groupLabel": "Before you start",
    "label": "Open an invoice draft, review its details, then choose Issue Invoice when you are ready for the fina",
    "maxLength": 4000
  },
  "prepare.on-payments-open-invoices-find-an-issued-invoice-and-choose-open-bes": {
    "text": "On Payments, open Invoices, find an issued invoice, and choose Open beside it.",
    "groupId": "preparation",
    "groupLabel": "Before you start",
    "label": "On Payments, open Invoices, find an issued invoice, and choose Open beside it.",
    "maxLength": 4000
  },
  "prepare.this-guide-applies-when-an-invoice-reports-that-it-changed-elsewhere": {
    "text": "This guide applies when an invoice reports that it changed elsewhere. Open the affected invoice; do not create a conflict deliberately.",
    "groupId": "preparation",
    "groupLabel": "Before you start",
    "label": "This guide applies when an invoice reports that it changed elsewhere. Open the affected invoice; do ",
    "maxLength": 4000
  },
  "prepare.open-the-invoice-workspace-from-payments": {
    "text": "Open the invoice workspace from Payments.",
    "groupId": "preparation",
    "groupLabel": "Before you start",
    "label": "Open the invoice workspace from Payments.",
    "maxLength": 4000
  },
  "prepare.in-settings-choose-value-from-the-settings-navigation": {
    "text": "In Settings, choose {page} from the Settings navigation.",
    "groupId": "preparation",
    "groupLabel": "Before you start",
    "label": "In Settings, choose [page] from the Settings navigation.",
    "maxLength": 4000
  },
  "prepare.open-value-in-value": {
    "text": "Open {window} in {area}.",
    "groupId": "preparation",
    "groupLabel": "Before you start",
    "label": "Open [window] in [area].",
    "maxLength": 4000
  },
  "prepare.value-then-use-the-guide-icon-in-that-window-or-page-to-start-the-ma": {
    "text": "{instruction} Then use the Guide icon in that window or page to start the matching guide. Guide will not create or submit anything while opening an area.",
    "groupId": "preparation",
    "groupLabel": "Before you start",
    "label": "[instruction] Then use the Guide icon in that window or page to start the matching guide. Guide will",
    "maxLength": 4000
  },
  "ui.resume": {
    "text": "Resume",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Resume",
    "maxLength": 240
  },
  "ui.guide": {
    "text": "Guide",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Guide",
    "maxLength": 240
  },
  "ui.saved": {
    "text": "Saved",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Saved",
    "maxLength": 240
  },
  "ui.open": {
    "text": "Open",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Open",
    "maxLength": 240
  },
  "ui.resume-guide": {
    "text": "Resume Guide",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Resume Guide",
    "maxLength": 240
  },
  "ui.try-saving-again": {
    "text": "Try saving again",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Try saving again",
    "maxLength": 240
  },
  "ui.continue-for-now": {
    "text": "Continue for now",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Continue for now",
    "maxLength": 240
  },
  "ui.guided-walkthrough": {
    "text": "Guided walkthrough",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Guided walkthrough",
    "maxLength": 240
  },
  "ui.review": {
    "text": "Review",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Review",
    "maxLength": 240
  },
  "ui.safe-practice": {
    "text": "Safe practice",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Safe practice",
    "maxLength": 240
  },
  "ui.reference": {
    "text": "Reference",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Reference",
    "maxLength": 240
  },
  "ui.settings-value": {
    "text": "Settings · {page}",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Settings · [page]",
    "maxLength": 240
  },
  "ui.open-its-window-first": {
    "text": "Open its window first",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Open its window first",
    "maxLength": 240
  },
  "ui.open-this-settings-page-first": {
    "text": "Open this Settings page first",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Open this Settings page first",
    "maxLength": 240
  },
  "ui.open-its-menu-first": {
    "text": "Open its menu first",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Open its menu first",
    "maxLength": 240
  },
  "ui.ready-here": {
    "text": "Ready here",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Ready here",
    "maxLength": 240
  },
  "ui.opens-this-area": {
    "text": "Opens this area",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Opens this area",
    "maxLength": 240
  },
  "ui.show-me": {
    "text": "Show me",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Show me",
    "maxLength": 240
  },
  "ui.show-me-where-to-go": {
    "text": "Show me where to go",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Show me where to go",
    "maxLength": 240
  },
  "ui.continue-in-value": {
    "text": "Continue in {area}",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Continue in [area]",
    "maxLength": 240
  },
  "ui.open-value-and-show-me": {
    "text": "Open {area} and show me",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Open [area] and show me",
    "maxLength": 240
  },
  "ui.open-value": {
    "text": "Open {area}",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Open [area]",
    "maxLength": 240
  },
  "ui.this-tutor-desk-page": {
    "text": "this Tutor Desk page",
    "groupId": "context-explanations",
    "groupLabel": "Window and menu explanations",
    "label": "this Tutor Desk page",
    "maxLength": 240
  },
  "ui.this-value": {
    "text": "this {kind}",
    "groupId": "context-explanations",
    "groupLabel": "Window and menu explanations",
    "label": "this [kind]",
    "maxLength": 240
  },
  "ui.understand-value": {
    "text": "Understand {namedContext}",
    "groupId": "context-explanations",
    "groupLabel": "Window and menu explanations",
    "label": "Understand [namedContext]",
    "maxLength": 240
  },
  "ui.learn-what-value-asks-for-and-what-its-buttons-will-do-before-you-co": {
    "text": "Learn what {namedContext} asks for and what its buttons will do before you continue.",
    "groupId": "context-explanations",
    "groupLabel": "Window and menu explanations",
    "label": "Learn what [namedContext] asks for and what its buttons will do before you continue.",
    "maxLength": 4000
  },
  "ui.learn-what-each-choice-in-value-will-do-before-you-choose-one": {
    "text": "Learn what each choice in {namedContext} will do before you choose one.",
    "groupId": "context-explanations",
    "groupLabel": "Window and menu explanations",
    "label": "Learn what each choice in [namedContext] will do before you choose one.",
    "maxLength": 4000
  },
  "ui.check-value-the-available-buttons-are-value-read-any-message-shown-b": {
    "text": "Check {fieldList}. The available buttons are {actionList}. Read any message shown before you choose a button.",
    "groupId": "context-explanations",
    "groupLabel": "Window and menu explanations",
    "label": "Check [fieldList]. The available buttons are [actionList]. Read any message shown before you choose ",
    "maxLength": 4000
  },
  "ui.check-value-read-any-message-shown-and-review-the-buttons-at-the-bot": {
    "text": "Check {fieldList}, read any message shown, and review the buttons at the bottom before you continue.",
    "groupId": "context-explanations",
    "groupLabel": "Window and menu explanations",
    "label": "Check [fieldList], read any message shown, and review the buttons at the bottom before you continue.",
    "maxLength": 4000
  },
  "ui.read-the-information-in-this-window-and-any-message-shown-the-availa": {
    "text": "Read the information in this window and any message shown. The available buttons are {actionList}.",
    "groupId": "context-explanations",
    "groupLabel": "Window and menu explanations",
    "label": "Read the information in this window and any message shown. The available buttons are [actionList].",
    "maxLength": 4000
  },
  "ui.read-the-information-already-shown-any-message-and-the-buttons-at-th": {
    "text": "Read the information already shown, any message, and the buttons at the bottom before you continue.",
    "groupId": "context-explanations",
    "groupLabel": "Window and menu explanations",
    "label": "Read the information already shown, any message, and the buttons at the bottom before you continue.",
    "maxLength": 4000
  },
  "ui.this-menu-offers-value-choose-only-the-option-that-matches-what-you": {
    "text": "This menu offers {actionList}. Choose only the option that matches what you want to do on {area}.",
    "groupId": "context-explanations",
    "groupLabel": "Window and menu explanations",
    "label": "This menu offers [actionList]. Choose only the option that matches what you want to do on [area].",
    "maxLength": 4000
  },
  "ui.read-each-choice-in-this-menu-choose-only-the-option-that-matches-wh": {
    "text": "Read each choice in this menu. Choose only the option that matches what you want to do on {area}.",
    "groupId": "context-explanations",
    "groupLabel": "Window and menu explanations",
    "label": "Read each choice in this menu. Choose only the option that matches what you want to do on [area].",
    "maxLength": 4000
  },
  "ui.this-window-belongs-to-value-checking-its-information-and-buttons-he": {
    "text": "This window belongs to {area}. Checking its information and buttons helps you avoid saving, sending, or changing the wrong thing.",
    "groupId": "context-explanations",
    "groupLabel": "Window and menu explanations",
    "label": "This window belongs to [area]. Checking its information and buttons helps you avoid saving, sending,",
    "maxLength": 4000
  },
  "ui.menu-choices-can-change-with-the-page-what-you-selected-and-what-you": {
    "text": "Menu choices can change with the page, what you selected, and what your account is allowed to do. Reading them first helps you avoid the wrong action.",
    "groupId": "context-explanations",
    "groupLabel": "Window and menu explanations",
    "label": "Menu choices can change with the page, what you selected, and what your account is allowed to do. Re",
    "maxLength": 4000
  },
  "ui.you-know-what-this-window-needs-and-what-its-available-buttons-will": {
    "text": "You know what this window needs and what its available buttons will do. Guide does not choose, save, send, delete, or confirm anything for you.",
    "groupId": "context-explanations",
    "groupLabel": "Window and menu explanations",
    "label": "You know what this window needs and what its available buttons will do. Guide does not choose, save,",
    "maxLength": 4000
  },
  "ui.you-know-which-menu-choice-fits-your-goal-closing-the-menu-changes-n": {
    "text": "You know which menu choice fits your goal. Closing the menu changes nothing.",
    "groupId": "context-explanations",
    "groupLabel": "Window and menu explanations",
    "label": "You know which menu choice fits your goal. Closing the menu changes nothing.",
    "maxLength": 4000
  },
  "ui.this-part-of-tutor-desk-is-still-loading-wait-a-moment-then-try-guid": {
    "text": "This part of Tutor Desk is still loading. Wait a moment, then try Guide again.",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "This part of Tutor Desk is still loading. Wait a moment, then try Guide again.",
    "maxLength": 4000
  },
  "ui.your-account-cannot-use-a-guide-for-this-page-you-can-still-use-the": {
    "text": "Your account cannot use a guide for this page. You can still use the page normally.",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Your account cannot use a guide for this page. You can still use the page normally.",
    "maxLength": 4000
  },
  "ui.this-page-is-changing-right-now-close-any-extra-open-window-then-try": {
    "text": "This page is changing right now. Close any extra open window, then try Guide again.",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "This page is changing right now. Close any extra open window, then try Guide again.",
    "maxLength": 4000
  },
  "ui.settings-is-still-opening": {
    "text": "Settings is still opening",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Settings is still opening",
    "maxLength": 240
  },
  "ui.guide-is-waiting-for-this-settings-panel-to-finish-opening-recommend": {
    "text": "Guide is waiting for this Settings panel to finish opening. Recommendations will appear automatically.",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Guide is waiting for this Settings panel to finish opening. Recommendations will appear automaticall",
    "maxLength": 4000
  },
  "ui.the-part-explained-by-this-guide-is-not-ready-yet-finish-opening-thi": {
    "text": "The part explained by this guide is not ready yet. Finish opening this page, then try again.",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "The part explained by this guide is not ready yet. Finish opening this page, then try again.",
    "maxLength": 4000
  },
  "ui.there-is-no-guide-for-this-page-yet-you-can-browse-all-guides-or-kee": {
    "text": "There is no guide for this page yet. You can browse all guides or keep using Tutor Desk normally.",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "There is no guide for this page yet. You can browse all guides or keep using Tutor Desk normally.",
    "maxLength": 4000
  },
  "ui.guide-all-eligible-guides": {
    "text": "Guide · All eligible guides",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Guide · All eligible guides",
    "maxLength": 240
  },
  "ui.browse-all-guides": {
    "text": "Browse all guides",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Browse all guides",
    "maxLength": 240
  },
  "ui.what-would-you-like-to-do": {
    "text": "What would you like to do?",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "What would you like to do?",
    "maxLength": 4000
  },
  "ui.search-every-available-guide-by-page-task-or-words-you-remember-choo": {
    "text": "Search every available guide by page, task, or words you remember. Choose a result to start here or open its Tutor Desk area.",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Search every available guide by page, task, or words you remember. Choose a result to start here or ",
    "maxLength": 4000
  },
  "ui.choose-a-goal-guide-will-point-to-each-real-control-while-you-stay-i": {
    "text": "Choose a goal. Guide will point to each real control while you stay in charge.",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Choose a goal. Guide will point to each real control while you stay in charge.",
    "maxLength": 4000
  },
  "ui.search-pages-tasks-or-help": {
    "text": "Search pages, tasks, or help",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Search pages, tasks, or help",
    "maxLength": 240
  },
  "ui.search-all-guides": {
    "text": "Search all guides",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Search all guides",
    "maxLength": 240
  },
  "ui.clear-search": {
    "text": "Clear search",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Clear search",
    "maxLength": 240
  },
  "ui.close-guide": {
    "text": "Close Guide",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Close Guide",
    "maxLength": 240
  },
  "ui.close": {
    "text": "Close",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Close",
    "maxLength": 240
  },
  "ui.available-guide-count": {
    "text": "{count} available {noun}",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "{count} available {noun}",
    "maxLength": 240
  },
  "ui.no-matching-guides": {
    "text": "No matching guides",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "No matching guides",
    "maxLength": 240
  },
  "ui.try-a-page-name-a-button-name-or-a-shorter-word": {
    "text": "Try a page name, a button name, or a shorter word.",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Try a page name, a button name, or a shorter word.",
    "maxLength": 4000
  },
  "ui.esc-closes": {
    "text": "Esc closes",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Esc closes",
    "maxLength": 240
  },
  "ui.recommended": {
    "text": "Recommended",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Recommended",
    "maxLength": 240
  },
  "ui.this-saved-guide-needs-an-update-before-it-can-continue-guide-stoppe": {
    "text": "This saved guide needs an update before it can continue. Guide stopped instead of restoring instructions from a missing or incompatible version.",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "This saved guide needs an update before it can continue. Guide stopped instead of restoring instruct",
    "maxLength": 4000
  },
  "ui.this-saved-guide-needs-permission-to-continue-guide-stopped-because": {
    "text": "This saved guide needs permission to continue. Guide stopped because your current Tutor Desk access no longer authorizes the workflow.",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "This saved guide needs permission to continue. Guide stopped because your current Tutor Desk access ",
    "maxLength": 4000
  },
  "ui.the-saved-guide-no-longer-matches-this-exact-screen-guide-stopped-in": {
    "text": "The saved guide no longer matches this exact screen. Guide stopped instead of restoring stale instructions in the wrong context.",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "The saved guide no longer matches this exact screen. Guide stopped instead of restoring stale instru",
    "maxLength": 4000
  },
  "ui.confirming-safe-progress": {
    "text": "Confirming safe progress…",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Confirming safe progress…",
    "maxLength": 240
  },
  "ui.hide": {
    "text": "Hide",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Hide",
    "maxLength": 240
  },
  "ui.retry": {
    "text": "Retry",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Retry",
    "maxLength": 240
  },
  "ui.exit": {
    "text": "Exit",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Exit",
    "maxLength": 240
  },
  "ui.back": {
    "text": "Back",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Back",
    "maxLength": 240
  },
  "ui.target-highlighted": {
    "text": "Target highlighted",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Target highlighted",
    "maxLength": 240
  },
  "ui.show-target": {
    "text": "Show target",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Show target",
    "maxLength": 240
  },
  "ui.next": {
    "text": "Next",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Next",
    "maxLength": 240
  },
  "ui.retry-check": {
    "text": "Retry check",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Retry check",
    "maxLength": 240
  },
  "ui.esc-hides-and-keeps-this-step": {
    "text": "Esc hides and keeps this step",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Esc hides and keeps this step",
    "maxLength": 240
  },
  "ui.this-part-of-tutor-desk-is-still-loading-your-place-is-saved-wait-a": {
    "text": "This part of Tutor Desk is still loading. Your place is saved; wait a moment, then try again.",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "This part of Tutor Desk is still loading. Your place is saved; wait a moment, then try again.",
    "maxLength": 4000
  },
  "ui.more-than-one-window-is-open-for-this-step-close-the-extra-window-th": {
    "text": "More than one window is open for this step. Close the extra window, then try again.",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "More than one window is open for this step. Close the extra window, then try again.",
    "maxLength": 4000
  },
  "ui.the-part-explained-by-this-step-is-not-ready-yet-finish-opening-it-t": {
    "text": "The part explained by this step is not ready yet. Finish opening it, then try again.",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "The part explained by this step is not ready yet. Finish opening it, then try again.",
    "maxLength": 4000
  },
  "ui.hide-guidance": {
    "text": "Hide guidance",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Hide guidance",
    "maxLength": 240
  },
  "ui.what-to-do": {
    "text": "What to do",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "What to do",
    "maxLength": 240
  },
  "ui.why-this-matters": {
    "text": "Why this matters",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Why this matters",
    "maxLength": 240
  },
  "ui.correct-result": {
    "text": "Correct result",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Correct result",
    "maxLength": 240
  },
  "ui.guide-is-confirming-that-this-tab-can-safely-save-progress-you-may-r": {
    "text": "Guide is confirming that this tab can safely save progress. You may review this instruction now; wait for confirmation before using the highlighted control or advancing.",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Guide is confirming that this tab can safely save progress. You may review this instruction now; wai",
    "maxLength": 4000
  },
  "ui.the-highlighted-area-is-above-what-you-can-see-choose-show-target-to": {
    "text": "The highlighted area is above what you can see. Choose Show target to bring it back.",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "The highlighted area is above what you can see. Choose Show target to bring it back.",
    "maxLength": 4000
  },
  "ui.the-highlighted-area-is-below-what-you-can-see-choose-show-target-to": {
    "text": "The highlighted area is below what you can see. Choose Show target to bring it back.",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "The highlighted area is below what you can see. Choose Show target to bring it back.",
    "maxLength": 4000
  },
  "ui.the-highlighted-area-is-to-the-left-of-what-you-can-see-choose-show": {
    "text": "The highlighted area is to the left of what you can see. Choose Show target to bring it back.",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "The highlighted area is to the left of what you can see. Choose Show target to bring it back.",
    "maxLength": 4000
  },
  "ui.the-highlighted-area-is-to-the-right-of-what-you-can-see-choose-show": {
    "text": "The highlighted area is to the right of what you can see. Choose Show target to bring it back.",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "The highlighted area is to the right of what you can see. Choose Show target to bring it back.",
    "maxLength": 4000
  },
  "ui.the-highlighted-area-is-partly-outside-what-you-can-see-choose-show": {
    "text": "The highlighted area is partly outside what you can see. Choose Show target to bring it back.",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "The highlighted area is partly outside what you can see. Choose Show target to bring it back.",
    "maxLength": 4000
  },
  "ui.guide-is-saving-your-place-hide-works-now-try-again-and-choose-anoth": {
    "text": "Guide is saving your place. Hide works now. Try again and Choose another guide will be ready in a moment.",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Guide is saving your place. Hide works now. Try again and Choose another guide will be ready in a mo",
    "maxLength": 4000
  },
  "ui.guide-is-ready-you-can-try-this-step-again-or-choose-another-guide": {
    "text": "Guide is ready. You can try this step again or choose another guide.",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Guide is ready. You can try this step again or choose another guide.",
    "maxLength": 4000
  },
  "ui.guide-needs-more-room": {
    "text": "Guide needs more room",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Guide needs more room",
    "maxLength": 240
  },
  "ui.this-step-needs-more-room": {
    "text": "This step needs more room",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "This step needs more room",
    "maxLength": 240
  },
  "ui.close-an-extra-window-or-make-tutor-desk-wider-then-choose-try-again": {
    "text": "Close an extra window or make Tutor Desk wider, then choose Try again. Nothing was changed.",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Close an extra window or make Tutor Desk wider, then choose Try again. Nothing was changed.",
    "maxLength": 4000
  },
  "ui.try-again": {
    "text": "Try again",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Try again",
    "maxLength": 240
  },
  "ui.choose-another-guide": {
    "text": "Choose another guide",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Choose another guide",
    "maxLength": 240
  },
  "ui.confirming-safe-progress-6c05450": {
    "text": "Confirming safe progress",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Confirming safe progress",
    "maxLength": 240
  },
  "ui.checking-the-current-tutor-desk-result": {
    "text": "Checking the current Tutor Desk result",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Checking the current Tutor Desk result",
    "maxLength": 240
  },
  "ui.tutor-desk-has-already-satisfied-the-visible-requirements-guide-is-c": {
    "text": "Tutor Desk has already satisfied the visible requirements. Guide is confirming that this tab can safely save progress before it reports completion.",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Tutor Desk has already satisfied the visible requirements. Guide is confirming that this tab can saf",
    "maxLength": 4000
  },
  "ui.esc-hides-and-keeps-this-check": {
    "text": "Esc hides and keeps this check",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Esc hides and keeps this check",
    "maxLength": 240
  },
  "ui.guide-step": {
    "text": "Guide step",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Guide step",
    "maxLength": 240
  },
  "ui.guide-waiting": {
    "text": "Guide waiting",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Guide waiting",
    "maxLength": 240
  },
  "ui.waiting-for-tutor-desk": {
    "text": "Waiting for Tutor Desk",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Waiting for Tutor Desk",
    "maxLength": 240
  },
  "ui.confirming-the-real-result": {
    "text": "Confirming the real result",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Confirming the real result",
    "maxLength": 240
  },
  "ui.guide-is-confirming-that-this-tab-can-safely-retain-the-pending-proo": {
    "text": "Guide is confirming that this tab can safely retain the pending proof. Advancement remains locked until confirmation.",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Guide is confirming that this tab can safely retain the pending proof. Advancement remains locked un",
    "maxLength": 4000
  },
  "ui.this-guide-does-not-have-a-page-to-open-yet-choose-another-guide": {
    "text": "This guide does not have a page to open yet. Choose another guide.",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "This guide does not have a page to open yet. Choose another guide.",
    "maxLength": 4000
  },
  "ui.use-the-main-menu-to-open-the-tutor-desk-area-you-want-guide-will-th": {
    "text": "Use the main menu to open the Tutor Desk area you want. Guide will then show the help for that page.",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Use the main menu to open the Tutor Desk area you want. Guide will then show the help for that page.",
    "maxLength": 4000
  },
  "ui.close-the-open-window-or-menu-first-so-nothing-you-entered-is-lost-t": {
    "text": "Close the open window or menu first so nothing you entered is lost. Then choose this guide again.",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Close the open window or menu first so nothing you entered is lost. Then choose this guide again.",
    "maxLength": 4000
  },
  "ui.open-value-from-the-main-menu-then-choose-this-guide-again": {
    "text": "Open {area} from the main menu, then choose this guide again.",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Open [area] from the main menu, then choose this guide again.",
    "maxLength": 4000
  },
  "ui.settings-is-not-available-in-your-current-navigation-check-your-acce": {
    "text": "Settings is not available in your current navigation. Check your access with the account owner.",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Settings is not available in your current navigation. Check your access with the account owner.",
    "maxLength": 4000
  },
  "ui.tutor-desk-could-not-open-value-use-the-main-menu-then-choose-this-g": {
    "text": "Tutor Desk could not open {area}. Use the main menu, then choose this guide again.",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Tutor Desk could not open [area]. Use the main menu, then choose this guide again.",
    "maxLength": 4000
  },
  "ui.value-did-not-finish-opening-try-again-or-use-the-main-menu": {
    "text": "{area} did not finish opening. Try again or use the main menu.",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "[area] did not finish opening. Try again or use the main menu.",
    "maxLength": 4000
  },
  "ui.choose-value": {
    "text": "choose {page}",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "choose [page]",
    "maxLength": 240
  },
  "ui.open-value-fb590c3": {
    "text": "open {window}",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "open [window]",
    "maxLength": 240
  },
  "ui.value-is-open-now-value-guide-will-recognize-it-and-explain-it": {
    "text": "{area} is open. Now {prerequisite}; Guide will recognize it and explain it.",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "[area] is open. Now [prerequisite]; Guide will recognize it and explain it.",
    "maxLength": 4000
  },
  "ui.this-part-of-tutor-desk-is-still-loading-wait-a-moment-then-try-agai": {
    "text": "This part of Tutor Desk is still loading. Wait a moment, then try again.",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "This part of Tutor Desk is still loading. Wait a moment, then try again.",
    "maxLength": 4000
  },
  "ui.this-page-changed-while-guide-was-opening-choose-a-guide-for-the-pag": {
    "text": "This page changed while Guide was opening. Choose a guide for the page you can see now.",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "This page changed while Guide was opening. Choose a guide for the page you can see now.",
    "maxLength": 4000
  },
  "ui.tutor-desk-has-not-supplied-matching-proof-for-this-result-retry-che": {
    "text": "Tutor Desk has not supplied matching proof for this result. Retry checked state only and did not resubmit the action.",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Tutor Desk has not supplied matching proof for this result. Retry checked state only and did not res",
    "maxLength": 4000
  },
  "ui.guidance-paused-safely": {
    "text": "Guidance paused safely",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Guidance paused safely",
    "maxLength": 240
  },
  "ui.this-saved-step-is-no-longer-valid-here": {
    "text": "This saved step is no longer valid here",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "This saved step is no longer valid here",
    "maxLength": 240
  },
  "ui.this-guide-needs-permission-to-continue": {
    "text": "This guide needs permission to continue",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "This guide needs permission to continue",
    "maxLength": 240
  },
  "ui.the-screen-or-prerequisite-state-changed-guide-will-not-restore-stal": {
    "text": "The screen or prerequisite state changed. Guide will not restore stale or misleading instructions.",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "The screen or prerequisite state changed. Guide will not restore stale or misleading instructions.",
    "maxLength": 4000
  },
  "ui.your-current-tutor-desk-access-no-longer-authorizes-this-workflow-gu": {
    "text": "Your current Tutor Desk access no longer authorizes this workflow. Guide preserved the step and will not reveal or advance instructions without permission.",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Your current Tutor Desk access no longer authorizes this workflow. Guide preserved the step and will",
    "maxLength": 4000
  },
  "ui.done": {
    "text": "Done",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Done",
    "maxLength": 240
  },
  "ui.exit-guide": {
    "text": "Exit guide",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Exit guide",
    "maxLength": 240
  },
  "ui.end-this-guide": {
    "text": "End this guide?",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "End this guide?",
    "maxLength": 4000
  },
  "ui.ending-this-instructional-session-clears-only-its-guide-progress-tut": {
    "text": "Ending this instructional session clears only its Guide progress. Tutor Desk data and completed host work will not be changed or reversed.",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Ending this instructional session clears only its Guide progress. Tutor Desk data and completed host",
    "maxLength": 4000
  },
  "ui.keep-guiding-me": {
    "text": "Keep guiding me",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Keep guiding me",
    "maxLength": 240
  },
  "ui.end-guide": {
    "text": "End guide",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "End guide",
    "maxLength": 240
  },
  "ui.verified-completion": {
    "text": "Verified completion",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Verified completion",
    "maxLength": 240
  },
  "ui.tutor-desk-confirmed-the-declared-result-guide-did-not-perform-the-b": {
    "text": "Tutor Desk confirmed the declared result. Guide did not perform the business action for you.",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Tutor Desk confirmed the declared result. Guide did not perform the business action for you.",
    "maxLength": 4000
  },
  "ui.was-this-guide-helpful-optional": {
    "text": "Was this guide helpful? Optional",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Was this guide helpful? Optional",
    "maxLength": 240
  },
  "ui.yes": {
    "text": "Yes",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Yes",
    "maxLength": 240
  },
  "ui.no": {
    "text": "No",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "No",
    "maxLength": 240
  },
  "ui.skip": {
    "text": "Skip",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Skip",
    "maxLength": 240
  },
  "ui.restart-guide": {
    "text": "Restart guide",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Restart guide",
    "maxLength": 240
  },
  "ui.restart-paused-safely": {
    "text": "Restart paused safely",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Restart paused safely",
    "maxLength": 240
  },
  "ui.reopen-the-required-screen-first": {
    "text": "Reopen the required screen first",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Reopen the required screen first",
    "maxLength": 240
  },
  "ui.the-completed-workflow-is-no-longer-open-guide-will-not-invent-missi": {
    "text": "The completed workflow is no longer open. Guide will not invent missing controls or ask you to repeat a real business action from the wrong screen.",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "The completed workflow is no longer open. Guide will not invent missing controls or ask you to repea",
    "maxLength": 4000
  },
  "ui.the-target-is-already-visible-and-highlighted": {
    "text": "The target is already visible and highlighted.",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "The target is already visible and highlighted.",
    "maxLength": 4000
  },
  "ui.the-target-was-brought-into-view-and-highlighted": {
    "text": "The target was brought into view and highlighted.",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "The target was brought into view and highlighted.",
    "maxLength": 4000
  },
  "ui.the-target-is-highlighted-guide-did-not-scroll-because-this-screen-h": {
    "text": "The target is highlighted. Guide did not scroll because this screen has no declared safe scroll area.",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "The target is highlighted. Guide did not scroll because this screen has no declared safe scroll area",
    "maxLength": 4000
  },
  "ui.feedback-skipped": {
    "text": "Feedback skipped",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Feedback skipped",
    "maxLength": 240
  },
  "ui.completion-remains-verified-you-can-still-finish-or-choose-another-g": {
    "text": "Completion remains verified. You can still finish or choose another guide.",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Completion remains verified. You can still finish or choose another guide.",
    "maxLength": 4000
  },
  "ui.thanks-for-the-feedback": {
    "text": "Thanks for the feedback",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Thanks for the feedback",
    "maxLength": 240
  },
  "ui.your-optional-guide-feedback-was-recorded-separately-from-verified-c": {
    "text": "Your optional Guide feedback was recorded separately from verified completion.",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Your optional Guide feedback was recorded separately from verified completion.",
    "maxLength": 4000
  },
  "ui.the-screen-context-changed-guide-paused-because-continuing-here-coul": {
    "text": "The screen context changed. Guide paused because continuing here could be misleading.",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "The screen context changed. Guide paused because continuing here could be misleading.",
    "maxLength": 4000
  },
  "ui.guide-coaching-tip": {
    "text": "Guide coaching tip",
    "groupId": "coaching-tips",
    "groupLabel": "Coaching tips",
    "label": "Guide coaching tip",
    "maxLength": 240
  },
  "ui.coaching-tips-stay-separate": {
    "text": "Coaching tips stay separate",
    "groupId": "coaching-tips",
    "groupLabel": "Coaching tips",
    "label": "Coaching tips stay separate",
    "maxLength": 240
  },
  "ui.small-first-use-tips-never-replace-the-full-task-picker-or-an-active": {
    "text": "Small first-use tips never replace the full task picker or an active Guide.",
    "groupId": "coaching-tips",
    "groupLabel": "Coaching tips",
    "label": "Small first-use tips never replace the full task picker or an active Guide.",
    "maxLength": 4000
  },
  "ui.dismiss-guide-coaching-tip": {
    "text": "Dismiss Guide coaching tip",
    "groupId": "coaching-tips",
    "groupLabel": "Coaching tips",
    "label": "Dismiss Guide coaching tip",
    "maxLength": 240
  },
  "ui.esc-dismisses": {
    "text": "Esc dismisses",
    "groupId": "coaching-tips",
    "groupLabel": "Coaching tips",
    "label": "Esc dismisses",
    "maxLength": 240
  },
  "ui.guide-could-not-be-loaded": {
    "text": "Guide could not be loaded",
    "groupId": "guide-startup",
    "groupLabel": "Opening Guide",
    "label": "Guide could not be loaded",
    "maxLength": 240
  },
  "ui.tutor-desk-did-not-provide-the-verified-guide-runtime-for-this-build": {
    "text": "Tutor Desk did not provide the verified Guide runtime for this build. Nothing was changed, and Guide will not substitute unverified instructions.",
    "groupId": "guide-startup",
    "groupLabel": "Opening Guide",
    "label": "Tutor Desk did not provide the verified Guide runtime for this build. Nothing was changed, and Guide",
    "maxLength": 4000
  },
  "ui.loading-guide": {
    "text": "Loading Guide",
    "groupId": "guide-startup",
    "groupLabel": "Opening Guide",
    "label": "Loading Guide",
    "maxLength": 240
  },
  "ui.checking-this-exact-screen": {
    "text": "Checking this exact screen",
    "groupId": "guide-startup",
    "groupLabel": "Opening Guide",
    "label": "Checking this exact screen",
    "maxLength": 240
  },
  "ui.guide-is-loading-the-verified-instructions-for-the-current-tutor-des": {
    "text": "Guide is loading the verified instructions for the current Tutor Desk build. It will stop safely if the context cannot be confirmed.",
    "groupId": "guide-startup",
    "groupLabel": "Opening Guide",
    "label": "Guide is loading the verified instructions for the current Tutor Desk build. It will stop safely if ",
    "maxLength": 4000
  },
  "ui.open-guide-for-this-dialog": {
    "text": "Open Guide for this dialog",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Open Guide for this dialog",
    "maxLength": 240
  },
  "ui.guide-for-this-dialog": {
    "text": "Guide for this dialog",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Guide for this dialog",
    "maxLength": 240
  },
  "ui.memory-only": {
    "text": "Guide is open, but your progress is not being saved. Reloading this page will restart this guide.",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Guide is open, but your progress is not being saved. Reloading this page will restart this guide.",
    "maxLength": 240
  },
  "ui.memory-only-recovered": {
    "text": "Your guide progress is being saved again.",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Your guide progress is being saved again.",
    "maxLength": 240
  },
  "ui.task-selected": {
    "text": " · task selected",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": " · task selected",
    "maxLength": 240
  },
  "ui.picker-eyebrow": {
    "text": "Guide · {context}{selection}",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Guide · {context}{selection}",
    "maxLength": 240
  },
  "ui.recommended-mode": {
    "text": "Recommended · {mode}",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Recommended · {mode}",
    "maxLength": 240
  },
  "ui.filtered-guide-count": {
    "text": "{count} of {total} available {noun}",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "{count} of {total} available {noun}",
    "maxLength": 240
  },
  "ui.guide-singular": {
    "text": "guide",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "guide",
    "maxLength": 240
  },
  "ui.guide-plural": {
    "text": "guides",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "guides",
    "maxLength": 240
  },
  "ui.recommended-for": {
    "text": "Recommended for {scope}",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Recommended for {scope}",
    "maxLength": 240
  },
  "ui.scope-dialog": {
    "text": "this dialog",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "this dialog",
    "maxLength": 240
  },
  "ui.scope-panel": {
    "text": "this panel",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "this panel",
    "maxLength": 240
  },
  "ui.scope-menu": {
    "text": "this menu",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "this menu",
    "maxLength": 240
  },
  "ui.scope-page": {
    "text": "this page",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "this page",
    "maxLength": 240
  },
  "ui.preparation-heading": {
    "text": "Before you start: {title}",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Before you start: {title}",
    "maxLength": 240
  },
  "ui.step-count": {
    "text": "Step {index} of {total}{review}",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Step {index} of {total}{review}",
    "maxLength": 240
  },
  "ui.review-suffix": {
    "text": " · Review",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": " · Review",
    "maxLength": 240
  },
  "ui.completed-title": {
    "text": "{title} is complete",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "{title} is complete",
    "maxLength": 240
  },
  "ui.waiting-result": {
    "text": "Guide is waiting for Tutor Desk to confirm the declared result: {result}. It will not resubmit the action.",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "Guide is waiting for Tutor Desk to confirm the declared result: {result}. It will not resubmit the action.",
    "maxLength": 240
  },
  "ui.expected-result-fallback": {
    "text": "the intended result",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "the intended result",
    "maxLength": 240
  },
  "ui.context-dialog": {
    "text": "dialog",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "dialog",
    "maxLength": 240
  },
  "ui.context-menu": {
    "text": "menu",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "menu",
    "maxLength": 240
  },
  "ui.context-window": {
    "text": "window",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "window",
    "maxLength": 240
  },
  "ui.context-panel": {
    "text": "panel",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "panel",
    "maxLength": 240
  },
  "ui.context-setting": {
    "text": "setting",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "setting",
    "maxLength": 240
  },
  "ui.matching-window": {
    "text": "the matching window",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "the matching window",
    "maxLength": 240
  },
  "ui.matching-page": {
    "text": "the matching page",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "the matching page",
    "maxLength": 240
  },
  "ui.matching-menu": {
    "text": "the matching menu",
    "groupId": "guide-controls",
    "groupLabel": "Guide controls and messages",
    "label": "the matching menu",
    "maxLength": 240
  },
  "prepare.support-report": {
    "text": "Choose Help in the page toolbar, then choose Report a Problem.",
    "groupId": "preparation",
    "groupLabel": "Before you start",
    "label": "Choose Help in the page toolbar, then choose Report a Problem.",
    "maxLength": 240
  },
  "prepare.student-shared-links": {
    "text": "Open Portal, select the student, then choose Manage shared links.",
    "groupId": "preparation",
    "groupLabel": "Before you start",
    "label": "Open the selected student's Shared links window",
    "maxLength": 1000
  },
  "prepare.worked-hours": {
    "text": "Choose Quick Actions → Worked Hours on Home or Payments.",
    "groupId": "preparation",
    "groupLabel": "Before you start",
    "label": "Choose Quick Actions → Worked Hours on Home or Payments.",
    "maxLength": 240
  },
  "prepare.data-analysis": {
    "text": "Choose Quick Actions → Data Analysis on Home.",
    "groupId": "preparation",
    "groupLabel": "Before you start",
    "label": "Choose Quick Actions → Data Analysis on Home.",
    "maxLength": 240
  }
});

export const TUTOR_DESK_GUIDE_DIALOG_COPY = Object.freeze({
  "delete-subject": {
    "matchTitle": "Delete Subject",
    "title": "Understand Delete Subject",
    "summary": "Check whether this subject can be removed without losing lesson history.",
    "what": "Check the subject name and any message about attached lessons. If deletion is allowed, Yes confirms removal and No keeps the subject. If the dialog says deletion is blocked, close it and keep the subject used by those lessons.",
    "why": "A subject used by saved lessons is part of their history. The displayed restriction protects those existing lesson records.",
    "expectedResult": "You understand the subject and its deletion eligibility before confirming. Guide never removes a subject or changes its attached lessons."
  },
  "archive-student": {
    "matchTitle": "Archive Student",
    "title": "Understand Archive Student",
    "summary": "Check the student before moving their record out of the normal list.",
    "what": "Confirm the student’s name and read the archive message. Archive changes the student’s status; Cancel keeps the current status. Use the archived-student view later when you need to find this record.",
    "why": "Archiving helps separate current students from inactive records without confusing them with a different student.",
    "expectedResult": "Only the intended student is archived after Tutor Desk confirms the action. Guide does not archive or remove any record for you."
  },
  "unarchive-student": {
    "matchTitle": "Unarchive Student",
    "title": "Understand Unarchive Student",
    "summary": "Choose the status the student should have when returning to the normal list.",
    "what": "Confirm the student’s name and choose Restore status, such as Active or Waiting. Unarchive returns this student to the normal Students list with that status. Cancel leaves the student archived.",
    "why": "The restored status determines how the student appears in later student and lesson work.",
    "expectedResult": "The intended student returns with the status you chose after Tutor Desk confirms the update."
  },
  "student-learning-snapshot": {
    "matchTitle": "Student Learning Snapshot",
    "title": "Understand Student Learning Snapshot",
    "summary": "Review the student’s learning summary against the lessons and evidence shown.",
    "what": "Check the selected student, completed lessons, subjects, upcoming lesson, and learning summary. Use the available lesson history to judge whether the summary accurately reflects the student’s progress.",
    "why": "An AI summary can miss context or describe evidence poorly. It should help you review the student, not replace your professional judgement.",
    "expectedResult": "You understand the student’s current learning picture and any gaps in the summary. Closing the snapshot does not change the student record."
  },
  "student-portal-linked": {
    "matchTitle": "Student Portal Linked",
    "title": "Understand Student Portal Linked",
    "summary": "Review Portal credentials, activation status, and the next access step.",
    "what": "Check the student, UserName, Password, Status, and Last Password Reset where shown. Copy copies the available credentials. Activate Student Portal enables access when that option is offered. A password reset opens a separate confirmation and replaces the current password.",
    "why": "Linking, activating, and resetting access have different effects. Check the displayed status before sharing credentials securely with the intended parent or guardian.",
    "expectedResult": "You know whether access is linked, active, or still needs an action. Guide never copies, activates, resets, or shares credentials for you."
  },
  "reset-portal-password": {
    "matchTitle": "Reset Portal Password",
    "title": "Understand Reset Portal Password",
    "summary": "Confirm the student before replacing the Portal’s current password.",
    "what": "Check the student’s name. Reset Password creates a new temporary password and stops the current password from working immediately. Cancel keeps the current password. After a confirmed reset, share the new credentials securely with the intended parent or guardian.",
    "why": "A reset changes how the student signs in. Resetting the wrong account can interrupt another student’s access.",
    "expectedResult": "You understand which account will change before confirming. Guide does not reset the password or disclose credentials."
  },
  "student-portal-logins": {
    "matchTitle": "Student Portal Logins",
    "title": "Understand Student Portal Logins",
    "summary": "Check the selected student’s recorded Portal sign-ins and their timestamps.",
    "what": "Review the student scope and the Date, Time, and IP address shown for each login. Check any loading or empty-state message before concluding that no logins exist.",
    "why": "Login history can help investigate access questions, but an IP address alone does not prove who used the account.",
    "expectedResult": "You can explain the displayed sign-in history and its limits. Closing the history does not change credentials or access."
  },
  "requested-lessons": {
    "matchTitle": "Requested Lessons",
    "title": "Understand Requested Lessons",
    "summary": "Review student-requested lesson times before confirming or declining each request.",
    "what": "Check each student, requested date, start time, subject, and duration. Confirm accepts the selected request when Tutor Desk permits it. Decline opens the reason form. Review conflicts and errors before deciding.",
    "why": "A request is not yet the same as a confirmed lesson. The selected decision must match the correct student and requested time.",
    "expectedResult": "You know which request you are accepting or declining. The resulting status and any email depend on Tutor Desk’s confirmation and notification policy."
  },
  "confirm-approved-time": {
    "matchTitle": "Confirm Approved Time",
    "title": "Understand Confirm Approved Time",
    "summary": "Check the actual teaching time and final amount before completing the lesson.",
    "what": "Review Approved time and Final amount. If a different approved time is needed, choose it before the final confirmation. Confirm only when the displayed minutes match the time that should be recorded for this lesson.",
    "why": "Approved minutes affect the completed lesson’s amount. A last review catches a duration or price error before completion is saved.",
    "expectedResult": "The completed lesson records the intended approved time after Tutor Desk confirms the save. Guide never submits the confirmation."
  },
  "delete-progress-check": {
    "matchTitle": "Delete progress check?",
    "title": "Understand Delete progress check?",
    "summary": "Review the learning evidence that will be removed with this progress check.",
    "what": "Check the student, progress check, and warning about suggested goal progress. Delete progress check removes this check and its connected ratings; Keep progress check cancels the deletion.",
    "why": "Removing measured evidence can change the suggested progress of connected learning goals.",
    "expectedResult": "You understand which check and ratings will be removed before deciding. Guide never deletes learning evidence for you."
  },
  "delete-learning-goal": {
    "matchTitle": "Delete learning goal?",
    "title": "Understand Delete learning goal?",
    "summary": "Check the learning goal and its evidence before confirming deletion.",
    "what": "Read the goal title and the message about saved lesson or progress-check ratings. Delete goal removes the eligible goal; Keep goal cancels. The dialog explains whether any historical evidence prevents deletion.",
    "why": "A goal helps explain the meaning of its success-step ratings. Tutor Desk preserves goals that are needed to understand saved evidence.",
    "expectedResult": "You know whether the goal can be deleted and what remains unchanged before confirming."
  },
  "this-goal-cannot-be-deleted": {
    "matchTitle": "This goal cannot be deleted",
    "title": "Understand This goal cannot be deleted",
    "summary": "Understand why Tutor Desk must preserve this goal’s learning history.",
    "what": "Read the count of saved success-step ratings from lessons or progress checks. These records use the goal, so deletion is blocked. Close returns to the goal without removing it.",
    "why": "Keeping the goal makes those historical ratings understandable instead of leaving them disconnected from their original target.",
    "expectedResult": "The goal and its evidence remain available. Guide does not offer a way around the deletion restriction."
  },
  "review-goal-completion": {
    "matchTitle": "Review goal completion",
    "title": "Understand Review goal completion",
    "summary": "Decide whether the student has met every success step for this goal.",
    "what": "Read the goal title, Tutor Desk’s progress estimate, and the evidence-quality message. Choose Yes, mark completed only when you have enough evidence. Keep active leaves the goal available for further work.",
    "why": "The progress estimate supports your review; it does not make the final completion decision for you.",
    "expectedResult": "The goal is completed only after your explicit confirmation, or remains active when more evidence is needed."
  },
  "remove-resource": {
    "matchTitle": "Remove Resource",
    "title": "Understand Remove Resource",
    "summary": "Check the learning resource before removing its Library catalog entry.",
    "what": "Check the resource title in the confirmation. Remove takes it out of the catalog; Cancel keeps it. The original file or external link is not deleted, and the catalog removal can be undone.",
    "why": "Catalog removal and deleting the original learning material are different actions. Check the named resource before changing its visibility in Library.",
    "expectedResult": "Only the intended catalog entry is removed after confirmation. Guide does not delete a file or open an external link."
  },
  "digital-library-web-mode": {
    "matchTitle": "Digital Library Web Mode",
    "title": "Understand Digital Library Web Mode",
    "summary": "Understand which Library resources are available in the current browser.",
    "what": "Use web links in this browser. Files, folders, and external drives require Tutor Desk Desktop. Close this message and choose a link, or use Desktop for a resource stored on the device.",
    "why": "A browser cannot provide the same local-file and external-drive access as the Desktop application.",
    "expectedResult": "You know which Library action can work in this environment without assuming that local files have been uploaded or synced."
  },
  "delete-lesson": {
    "matchTitle": "Delete lesson?",
    "title": "Understand Delete lesson?",
    "summary": "Check the lesson identity before a permanent deletion from the audit workflow.",
    "what": "Check Student, Date and time, and Status in this confirmation. Delete Lesson permanently removes this lesson and cannot be undone. Close returns without deleting it.",
    "why": "A permanent deletion removes an existing lesson record, so its identity must match the record you intended to remove.",
    "expectedResult": "You understand which lesson will be permanently removed before confirming. Guide never deletes a lesson for you."
  },
  "save-lesson-changes": {
    "matchTitle": "Save lesson changes?",
    "title": "Understand Save lesson changes?",
    "summary": "Confirm the corrected lesson identity and status before applying the edit.",
    "what": "Check Student, Date and time, and Status. Save Changes applies the correction you reviewed in Audit Lesson. Close returns to the previous view without confirming this save.",
    "why": "The correction belongs to an existing lesson and should accurately describe its schedule and outcome.",
    "expectedResult": "Tutor Desk saves the intended correction only after your confirmation. Guide never submits an audit change for you."
  },
  "approve-guidance": {
    "matchTitle": "Approve Guidance",
    "title": "Understand Approve Guidance",
    "summary": "Review the tested AI guidance before approving its use in future summaries.",
    "what": "Check the proposed guidance, issue, supporting evidence, and test result. Approve accepts the selected guidance after this confirmation. Cancel leaves the proposal unchanged.",
    "why": "Approved guidance can affect future AI wording, so the evidence should show why this specific change is appropriate.",
    "expectedResult": "You understand the effect of the proposed guidance before confirming approval. Guide never approves an AI change for you."
  },
  "reject-guidance": {
    "matchTitle": "Reject Guidance",
    "title": "Understand Reject Guidance",
    "summary": "Confirm which AI guidance proposal should be rejected after review.",
    "what": "Check the selected guidance and the evidence that makes it unsuitable. Reject rejects this proposal; Cancel returns without submitting the decision.",
    "why": "A rejection should apply to the exact proposal you reviewed so a different useful change is not rejected by mistake.",
    "expectedResult": "Only the intended proposal is rejected after confirmation. Guide never chooses or submits the decision for you."
  },
  "roll-back-guidance": {
    "matchTitle": "Roll Back Guidance",
    "title": "Understand Roll Back Guidance",
    "summary": "Review the active AI guidance before undoing that guidance change.",
    "what": "Check the selected guidance, its current state, and the rollback explanation. Roll Back reverses the selected guidance change when allowed; Cancel leaves it as it is.",
    "why": "Rolling back guidance affects future AI behaviour and should be based on evidence that the current change is unsuitable.",
    "expectedResult": "You understand the selected rollback before confirming it. Guide does not roll back guidance or rewrite past summaries."
  }
});
